import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const CheckCircleSolidIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('CheckCircleSolidIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      fillRule="evenodd"
      d="M8 15.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m3.327-9.146a.698.698 0 0 0-1.072-.894l-3 3.6-1.552-1.553a.698.698 0 0 0-.987.986l2.093 2.093a.697.697 0 0 0 1.03-.046z"
      clipRule="evenodd"
    />
  </svg>
);
CheckCircleSolidIcon.id = 'CheckCircleSolidIcon';
CheckCircleSolidIcon.displayName = 'CheckCircleSolidIcon';
export default CheckCircleSolidIcon;
